export default __webpack_public_path__ + "static/media/promo-banner-11-11-2022.5db87575.svg";